import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Image from 'components/Image';

import appContent from 'helpers/appContent';

const icons = {
  '': 'align-right',
  autoPlay: 'play',
  Photo: 'images',
};

const Sidebar = ({ currentPage, image, items, onClick }) => (
  <ul className="sidebar">
    {image && <Image src={appContent(image)} alt={image} className="header__image" />}
    {items.map(({ name, type, upID }, i) => (
      <button key={name} onClick={() => onClick(i)} type="button">
        <li className={clsx({ active: upID === currentPage.upID })}>
          <FontAwesomeIcon icon={['fas', icons[type]]} />
          <span>{name}</span>
        </li>
      </button>
    ))}
  </ul>
);

export default Sidebar;

Sidebar.propTypes = {
  currentPage: PropTypes.shape({
    upID: PropTypes.string,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.oneOf(['', 'autoPlay', 'Photo']),
    }),
  ),
  image: PropTypes.string,
  onClick: PropTypes.string,
};

Sidebar.defaultProps = {
  currentPage: {},
  items: [],
  image: null,
  onClick: () => {},
};
